import { connect } from 'react-redux';
import PrivacyPolicyControlView from './PrivacyPolicyControlView.jsx';
import hasAccess from 'src/legacy/services/hasAccess.jsx';
import { updatePrivacyPolicyControl } from 'src/redux/actions/accounts.ts';
import _ from "lodash";

const mapStateToProps = (state, ownProps) => {
  return {
    account: state.accounts.item,
    updating: _.get(state.accounts, "privacyPolicyControl.updating", false),
    updated: _.get(state.accounts, "privacyPolicyControl.updated", false),
    error: _.get(state.accounts, "privacyPolicyControl.error")
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updatePrivacyPolicyControl: (privacyPolicyData, consentRequired) => {
        return dispatch(updatePrivacyPolicyControl(privacyPolicyData, consentRequired));
      }
  }
}

const PrivacyPolicyControlPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(PrivacyPolicyControlView);

export default hasAccess(PrivacyPolicyControlPage, 'privacy-policy');